import axiosClient from "./axios";
import axios from "axios";
import axiosImage from "./axiosImage";
import Cookies from "js-cookie";

const apiUrl = "https://be.qriend.app/api";

// Axios instance oluştur
const axiosInstance = axios.create({
  baseURL: apiUrl,
  withCredentials: true, // CORS için önemli
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const getPackages = async () => {
  const response = await axiosClient.get(`/packages/getPackages`);
  return response.data;
};

export const deleteQrCategory = async (id) => {
  const response = await axiosClient.delete(
    `/module/qrMenu/category/delete/` + id
  );
  return response.data;
};

export const postCurrentPackage = async (id) => {
  const response = await axiosClient.post("/nacs/setCurrentPackage" + id);
  return response.data;
};

export const storePayment = async (data) => {
  const response = await axios.post(apiUrl + `/payment/pay`, data);
  return response.data;
};
// ---------------------------------------QRIEND API

// AuthController

// Token kontrolü için yardımcı fonksiyon
const getAuthHeader = () => {
  const token = Cookies.get("qriendtoken");
  if (!token) {
    return {};
  }
  return { Authorization: `Bearer ${token}` };
};

// Admin token kontrolü
export const verifyAdminToken = async () => {
  try {
    const headers = getAuthHeader();

    if (!headers.Authorization) {
      throw new Error("No token available for verification");
    }

    // Admin rolünü doğrudan kullanıcı bilgilerinden kontrol et
    const userStr = Cookies.get("user");
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        // role veya isAdmin kontrolü
        if (user.role === "admin" || user.isAdmin === true) {
          return { isAdmin: true, role: "admin", user };
        }
      } catch (e) {}
    }

    const response = await axiosInstance.get("/admin/verify", {
      headers,
      validateStatus: function (status) {
        return status < 500;
      },
    });

    if (response.status === 401 || response.status === 403) {
      return { isAdmin: false };
    }

    if (!response.data) {
      return { isAdmin: false };
    }

    // Backend'den gelen yanıtı detaylı kontrol et
    const isAdmin =
      response.data.isAdmin === true ||
      response.data.role === "admin" ||
      (response.data.user &&
        (response.data.user.role === "admin" ||
          response.data.user.isAdmin === true));

    return {
      isAdmin,
      ...response.data,
    };
  } catch (error) {
    // Network hatası durumunda cookie'deki bilgileri kullan
    const userStr = Cookies.get("user");
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user.role === "admin" || user.isAdmin === true) {
          return { isAdmin: true, role: "admin", user };
        }
      } catch (e) {}
    }
    return { isAdmin: false };
  }
};

export const login = async ({ email, password, rememberMe }) => {
  try {
    const response = await axiosInstance.post("/auth/login", {
      email,
      password,
      rememberMe,
    });

    // Login yanıtını kontrol et
    if (response.data && response.data.token) {
      // Token'ı kaydet
      Cookies.set("qriendtoken", response.data.token);

      // Kullanıcı bilgilerini kaydet
      if (response.data.user) {
        Cookies.set("user", JSON.stringify(response.data.user));
      }
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const register = async ({
  firstname,
  lastname,
  username,
  email,
  password,
  gender,
}) => {
  try {
    const response = await axios.post(apiUrl + "/auth/register", {
      name: firstname,
      surname: lastname,
      username,
      email,
      password,
      gender: gender ? gender.toUpperCase() : undefined,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// MessagesController
export const PostMessage = async (apiPayload) => {
  const response = await axiosClient.post("/messages/send", {
    data: apiPayload,
  });
  return response.data;
};

export const deleteMessage = async (id) => {
  const response = await axiosClient.delete("/messages/delete/" + id);
  return response.data;
};

export const PostMessageRead = async (id) => {
  const response = await axiosClient.post(`/message/` + id + "/read");
  return response.data;
};

export const getMessageVenue = async (id) => {
  const response = await axiosClient.get(`/get/messages/venue/${id}`);
  return response.data;
};

export const notifyNewVenueMessage = async (venueId, messagePayload) => {
  // messagePayload: { messageId, content, type, userId }
  try {
    const response = await axiosClient.post(
      `/messages/venue/${venueId}`,
      messagePayload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserProfile = async () => {
  const response = await axiosClient.get(`/users/profile`);
  return response.data;
};

// ---------------------------------------Mekan API (Venue/Group Management)

/**
 * @typedef {Object} VenueTime
 * @property {number} hour
 * @property {number} minute
 * @property {number} second
 * @property {number} nano
 */

/**
 * @typedef {Object} Venue
 * @property {string} id - UUID formatında
 * @property {string} name - Mekan adı
 * @property {string} address - Adres
 * @property {string} phoneNumber - Telefon numarası
 * @property {VenueTime} openingTime - Açılış saati
 * @property {VenueTime} closingTime - Kapanış saati
 * @property {string[]} workingDays - Çalışma günleri
 * @property {string} photoUrl - Fotoğraf URL'i
 * @property {string} description - Açıklama
 * @property {string} ownerName - Mekan sahibinin adı
 * @property {number} favoriteCount - Favori sayısı
 * @property {boolean} favorited - Favori durumu
 * @property {number} distance - Uzaklık
 * @property {number} currentVisitorCount - Mevcut ziyaretçi sayısı
 * @property {boolean} hasUserNote - Kullanıcı notu var mı
 * @property {number} userNoteId - Kullanıcı notu ID
 * @property {number} mutualFriendsCount - Ortak arkadaş sayısı
 * @property {string} venueType - Mekan tipi
 * @property {number} ownerId - Sahip ID
 * @property {number} latitude - Enlem
 * @property {number} longitude - Boylam
 */

export const getAllVenues = async () => {
  try {
    const response = await axiosClient.get("/admin/venues");

    if (response?.data) {
      const venuesData = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data.data)
        ? response.data.data
        : [];

      return venuesData;
    }

    return [];
  } catch (error) {
    if (!error.response) {
      throw new Error(
        "Sunucuya bağlanılamıyor. Lütfen internet bağlantınızı kontrol edin."
      );
    }

    throw new Error(
      error.response?.data?.message ||
        error.message ||
        "Mekanlar yüklenirken bir hata oluştu"
    );
  }
};

export const getVenueDetails = async (venueId) => {
  try {
    const response = await axiosClient.get(`/venues/${venueId}`);
    return response.data;
  } catch (error) {
    // HTTP status kodunu koruyarak hata fırlat
    const apiError = new Error(
      error.response?.data?.message ||
        error.message ||
        "Mekan detayları yüklenirken bir hata oluştu"
    );
    apiError.status = error.response?.status;
    apiError.response = error.response;
    throw apiError;
  }
};

export const createGroup = async (groupData) => {
  // groupData: { name, venueId, memberIds, description, isPrivate, joinRequiresApproval, maxMembers }
  const response = await axiosClient.post(`/groups`, groupData);
  return response.data;
};

export const getGroupsForVenue = async (venueId) => {
  // Bu endpoint'in API'nizde GET mi POST mu olduğunu kontrol edin.
  // Genellikle listeleme GET olur. Eğer POST ise, axiosClient.post kullanılmalı.
  const response = await axiosClient.get(`/groups/venue/${venueId}`);
  return response.data;
};

// getVenueGroups fonksiyonu zaten yukarıdakiyle aynı görünüyor,
// API'nizde /groups/venue/{venueId} için tek bir GET endpoint'i varsa biri gereksiz olabilir.
// Eğer farklı bir amaçları varsa isimlerini daha açıklayıcı yapabilirsiniz.
// Şimdilik birini bırakıyorum, gerekirse diğerini (getVenueGroups) silebilir veya amacına göre düzenleyebilirsiniz.

export const getGroupMembersList = async (groupId) => {
  const response = await axiosClient.get(`/groups/${groupId}/members`);
  return response.data;
};

export const checkVenueActiveGroupStatus = async (venueId) => {
  const response = await axiosClient.get(
    `/groups/venue/${venueId}/check-active`
  );
  return response.data;
};

export const getUserGroups = async (userId) => {
  const response = await axiosClient.get(`/groups/user/${userId}`);
  return response.data;
};

export const addMemberToGroup = async (groupId, userId, memberData = {}) => {
  // memberData, API'nizin beklediği ek bilgileri içerebilir (rol vb.)
  const response = await axiosClient.post(
    `/groups/${groupId}/members/${userId}`,
    memberData
  );
  return response.data;
};

export const updateGroupDetails = async (groupId, groupUpdateData) => {
  // groupUpdateData: { name, description, isPrivate, photoUrl, joinRequiresApproval, maxMembers }
  const response = await axiosClient.put(`/groups/${groupId}`, groupUpdateData);
  return response.data;
};

export const getCheckInCheck = async (venueId) => {
  const response = await axiosClient.get(
    "/locations/" + venueId + "/check-active"
  );
  return response.data;
};

export const postCheckIn = async (venueId) => {
  const response = await axiosClient.post(
    "/locations/" + venueId + "/check-in"
  );
  return response.data;
};

// export const getVenueData = async (id) => {
//   const response = await axiosClient.get("/venues/" + id);
//   return response.data;
// };



export const postAuthLogin = async (data) => {
  try {
    const response = await axios.post(apiUrl + "/auth/login", data);
    return response.data;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};
export const postForgotPassword = async (email) => {
  try {
    const response = await axios.post(apiUrl + "/auth/forgot-password", {
      email,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyResetCode = async (email, code) => {
  try {
    console.log("verifyResetCode çağrıldı - Email:", email, "Kod:", code);
    const requestData = {
      verificationCode: code,
      newPassword: "temporary_password_for_verification_only",
    };
    console.log("Gönderilen veri:", requestData);

    const response = await axiosInstance.post(
      `/auth/reset-password/${email}`,
      requestData
    );
    console.log("Backend yanıtı:", response.data);
    return response.data;
  } catch (error) {
    console.log("verifyResetCode hatası:", error);
    console.log("Hata detayları:", {
      message: error.message,
      response: error.response,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    throw error;
  }
};

export const resetPassword = async (email, code, newPassword) => {
  try {
    console.log(
      "resetPassword çağrıldı - Email:",
      email,
      "Kod:",
      code,
      "Yeni şifre:",
      newPassword
    );
    const requestData = {
      email: email,
      verificationCode: code,
      newPassword: newPassword,
    };
    console.log("Gönderilen veri:", requestData);

    const response = await axios.post(
      apiUrl + `/auth/reset-password`,
      requestData
    );
    console.log("Backend yanıtı:", response.data);
    return response.data;
  } catch (error) {
    console.log("resetPassword hatası:", error);
    console.log("Hata detayları:", {
      message: error.message,
      response: error.response,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    throw error;
  }
};

// Extras API - Policy içeriklerini getirmek için
export const getExtrasContent = async (key) => {
  try {
    const response = await axiosClient.get(`/extras/${key}`);
    return response.data;
  } catch (error) {
    if (!error.response) {
      throw new Error(
        "Sunucuya bağlanılamıyor. Lütfen internet bağlantınızı kontrol edin."
      );
    }

    throw new Error(
      error.response?.data?.message ||
        error.message ||
        "İçerik yüklenirken bir hata oluştu"
    );
  }
};
